<figure #bfsGraph></figure>
<div *ngIf="bfsGraph">
	<nz-table class="bfa-age-table" [nzData]="['']" [nzFrontPagination]="false">
		<thead>
		<tr>
			<th nzWidth="80%"></th>
			<th nzWidth="20%"></th>
		</tr>
		</thead>
		<tbody>
			<tr>
				<td class="table-cell label-cell">{{this.actualAgeWord}}</td>
				<td class="table-cell value-cell" [ngStyle]="{'color': colors.actualAge}">{{this.participantActualAge}}{{this.actualAgeAbb}}</td>

			</tr>
			<tr>
				<td class="table-cell label-cell">{{this.bfAgeWord}}</td>
				<td class="table-cell value-cell" [ngStyle]="{'color': colors.bfAge}">{{this.interpolatedBfAge}}{{this.bfAgeAbb}}{{this.optionalValueRestrictionAsterisk}}</td>

			</tr>
		</tbody>
	</nz-table>
	<div *ngIf="isBfaValueRestricted" class="footnote">* Berechneter Wert ist niedriger/höher, Grenzwert wird ausgegeben</div>
</div>
